import type { ComponentProps } from 'react';

import { cn } from '@/design-system/lib/cn';

export type LabelProps = ComponentProps<'label'> & {
  /** Obrigatório: rótulo solto não vira nome acessível de campo nenhum. */
  htmlFor: string;
};

/** Rótulo de campo: 13px semibold. */
export function Label({ className, htmlFor, ...props }: LabelProps) {
  return (
    <label htmlFor={htmlFor} className={cn('text-small font-semibold text-ink', className)} {...props} />
  );
}
